<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- タイトル -->
    <div class="title">
      <h1>入会申請詳細</h1>
    </div>

    <!-- 内閣府承認情報 -->
    <div class="approval-information">
      <!-- 内閣府承認情報内容 -->
      <p-table [value]="[{}]" styleClass="information-Form">
        <ng-template pTemplate="body">
          <!-- 内閣府承認 -->
          <tr>
            <td class="item-name">運営事務局承認</td>
            <td class="item-information">
              <div [class.denial]="2 == applicationInformation?.status.id">
                <div class="p-d-flex status">
                  <label class="p-as-center">
                    <!-- ステータス -->
                    <label class="status-name">
                      {{ applicationInformation?.status.name }}
                    </label>
                    <!-- 承認日付 -->
                    <label>
                      {{ applicationInformation?.status_date }}
                    </label>
                  </label>

                  <!-- 承認可否 -->
                  <button
                    pButton
                    type="button"
                    label="ステータス登録"
                    class="button3 approval-button"
                    (click)="openSmallApprovalDialog()"
                  ></button>
                </div>
                <!-- 承認時コメント -->
                <div class="status-comment">
                  {{ applicationInformation?.status_comment }}
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- 申請情報 -->
    <div class="application-detail">
      <!-- タイトル -->
      <div class="application-detail-title">
        <h1>申請情報</h1>
      </div>
      <!-- 申請詳細 -->
      <div class="application-detail-information">
        <!-- 申請内容 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- 会員種別 -->
            <tr>
              <td class="item-input-name">会員種別</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ applicationInformation?.class_id.name }}
              </td>
            </tr>
            <!-- 団体名称 -->
            <tr>
              <td class="item-input-name">団体名称</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ applicationInformation?.organization_name }}
              </td>
            </tr>
            <!-- 団体名称フリガナ -->
            <tr>
              <td class="item-input-name">団体名称フリガナ</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ applicationInformation?.organization_kana }}
              </td>
            </tr>
            <!-- 法人番号 -->
            <tr>
              <td class="item-input-name">法人番号</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ applicationInformation?.organization_no }}
              </td>
            </tr>
            <!-- 郵便番号 -->
            <tr>
              <td class="item-input-name">郵便番号</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ applicationInformation?.postal_no }}
              </td>
            </tr>
            <!-- 都道府県 -->
            <tr>
              <td class="item-input-name">都道府県</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ applicationInformation?.prefectures }}
              </td>
            </tr>
            <!-- 所在地（市区町村） -->
            <tr>
              <td class="item-input-name">所在地（市区町村）</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ applicationInformation?.city }}
              </td>
            </tr>
            <!-- 所在地（町域） -->
            <tr>
              <td class="item-input-name">所在地（町域）</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ applicationInformation?.town_area }}
              </td>
            </tr>
            <!-- 所在地（番地・建物） -->
            <tr>
              <td class="item-input-name">所在地（番地・建物）</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ applicationInformation?.address_building }}
              </td>
            </tr>
            <!-- 業種 -->
            <tr>
              <td class="item-input-name">業種</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ applicationInformation?.industry_id.name }}
              </td>
            </tr>
            <!-- 団体ウェブサイトURL -->
            <tr>
              <td class="item-input-name">ウェブサイトURL</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                <a [href]="applicationInformation?.url" target="_blank"
                  >{{ applicationInformation?.url }}
                </a>
              </td>
            </tr>
            <!-- 部局名/事業名 -->
            <tr>
              <td class="item-input-name">部局名/事業名</td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ applicationInformation?.department_name }}
              </td>
            </tr>
            <!-- 課室名 -->
            <tr>
              <td class="item-input-name">課室名</td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ applicationInformation?.division_name }}
              </td>
            </tr>
            <!-- 役職 -->
            <tr>
              <td class="item-input-name">役職</td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ applicationInformation?.jobposition_name }}
              </td>
            </tr>
            <!-- 氏名 -->
            <tr>
              <td class="item-input-name">氏名</td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ applicationInformation?.full_name }}
              </td>
            </tr>
            <!-- 電話番号 -->
            <tr>
              <td class="item-input-name">電話番号</td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ applicationInformation?.tel }}
              </td>
            </tr>
            <!-- eメールアドレス -->
            <tr>
              <td class="item-input-name">eメールアドレス</td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ applicationInformation?.email }}
              </td>
            </tr>
            <!-- プラットフォーム誓約書-->
            <tr>
              <td class="item-input-name">プラットフォーム誓約書</td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="p-d-flex p-jc-cente item-information">
                <div class="p-as-center">
                  {{ applicationInformation?.pledge.name }}
                </div>
                <div class="file">
                  <!-- ファイルDL-->
                  <button
                    pButton
                    label="ダウンロード"
                    [value]="applicationInformation?.pledge.file_path"
                    onClick="location.href=this.value"
                    class="button1"
                    [disabled]="!applicationInformation?.pledge.file_path"
                  ></button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <!-- 入会時アンケート -->
    <div class="application-detail">
      <!-- タイトル -->
      <div class="application-detail-title">
        <h1>入会時アンケート</h1>
      </div>
      <!-- 申請詳細 -->
      <div class="application-detail-information">
        <!-- 申請内容 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- （1）本プラットフォームを知った・・・ -->
            <tr>
              <td class="item-name">
                （1）本プラットフォームを知った、または加入を希望したきっかけは何ですか。
              </td>
              <td class="item-information">
                <div *ngFor="let data of applicationInformation?.questionary1">
                  {{ data.order }}.{{ getDicName(801, data.id) }}
                </div>
                {{ applicationInformation?.questionary1_other }}
              </td>
            </tr>
            <!-- （2）本プラットフォームへの加入を希望する・・・ -->
            <tr>
              <td class="item-name">
                （2）本プラットフォームへの加入を希望する理由および本プラットフォームに期待することは何ですか。
              </td>
              <td class="item-information">
                <div *ngFor="let data of applicationInformation?.questionary2">
                  {{ data.order }}.{{ getDicName(802, data.id) }}
                </div>
                {{ applicationInformation?.questionary2_other }}
              </td>
            </tr>
            <!-- （3）本プラットフォームでは地方公共団体が抱える課題に対し・・・ -->
            <tr>
              <td class="item-name">
                （3）本プラットフォームでは地方公共団体が抱える課題に対し、協働で考え取り組む民間団体等と連携することを目的としたマッチング支援を実施しています。
                マッチングについて、どのような方法を希望しますか。
              </td>
              <td class="item-information">
                <div *ngFor="let data of applicationInformation?.questionary3">
                  {{ data.order }}.{{ getDicName(803, data.id) }}
                </div>
                {{ applicationInformation?.questionary3_other }}
              </td>
            </tr>
            <!-- （4）SDGs達成の観点から解決したい地域課題／貢献できるテーマ・・・ -->
            <tr>
              <td class="item-name">
                （4）地方創生SDGs官民連携プラットフォーム以外に、他の官民連携マッチングプラットフォームやサービスに加入・利用していますか。
              </td>
              <td class="item-information">
                <div *ngFor="let data of applicationInformation?.questionary4">
                  {{ data.order }}.{{ getDicName(804, data.id) }}
                </div>
                {{ applicationInformation?.questionary4_other }}
              </td>
            </tr>
            <!-- （5）本プラットフォームでは、会員間の共通の問題や課題に対する課題の検討の実施・・・ -->
            <tr>
              <td class="item-name">
                （5）上記問（４）にて他プラットフォーム・サービスに加入していると回答した場合（選択肢1.又は2.）、加入・利用している理由は何ですか。
              </td>
              <td class="item-information">
                <div *ngFor="let data of applicationInformation?.questionary5">
                  {{ data.order }}.{{ getDicName(805, data.id) }}
                </div>
                {{ applicationInformation?.questionary6 }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<!-- 共通部品_承認時ダイアログ -->
<app-approval-dialog
  (returnApproval)="getDetailApplication()"
></app-approval-dialog>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
